import styled from 'styled-components';

export const MissionsContainer = styled.div`
  width: 100%;
  padding: 0px 20px;
  left: 0;
  right: ${({ theme }) => theme.frameOffset};
  top: ${({ theme }) => theme.navHeight};  
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding: 0;
  }
`;